/* eslint-disable ember/no-classic-components, ember/require-tagless-components, warp-drive/no-legacy-request-patterns */
import Component from '@ember/component';
import { tracked } from '@glimmer/tracking';
import { service } from '@ember/service';
import { action } from '@ember/object';

export default class DragSortDialog extends Component {
  @service
  toaster;

  // entities accepts an array of entities with a `sequence` property.
  entities = null;

  // onClose accepts a function/action to be called to close the dialog.
  onClose() {}

  // title specifies the title of the sort dialog.
  title = 'Sort';

  // blurb specifies a blurb to be displayed in the dialog, above the list.
  blurb = '';

  // processing is an internal flag to mark when changes are being saved.
  @tracked
  processing = false;

  // sortDragEnd processes a list item being dragged and dropped.
  @action
  sortDragEnd({ sourceList, sourceIndex, targetList, targetIndex }) {
    if (sourceList === targetList && sourceIndex === targetIndex) {
      return;
    }

    this.processing = true;

    const item = sourceList[sourceIndex];

    sourceList.splice(sourceIndex, 1);
    targetList.splice(targetIndex, 0, item);

    let promises = [];
    targetList.forEach((entity, index) => {
      entity.set('sequence', index + 1);
      if (entity.hasDirtyAttributes) {
        promises.push(entity.save());
      }
    });

    Promise.all(promises)
      .catch(() => {
        // Something failed.  Roll back any unsaved changes.
        this.entities.forEach((entity) => entity.rollbackAttributes());
        this.toaster.error('Failed to update sort order.  Please try again.');
      })
      .finally(() => {
        this.processing = false;
      });
  }

  @action
  closeDialog() {
    this.onClose();
  }
}
